module.exports = __webpack_public_path__ + "assets/img/tracked-box1-next.f636343b.svg";